import { render } from "./ChatBotModalComponent.vue?vue&type=template&id=5827e282&scoped=true"
import script from "./ChatBotModalComponent.vue?vue&type=script&lang=js"
export * from "./ChatBotModalComponent.vue?vue&type=script&lang=js"

import "./ChatBotModalComponent.vue?vue&type=style&index=0&id=5827e282&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5827e282"]])

export default __exports__